import { useCallback } from "react";
import { deviceDetect, getUA } from "react-device-detect";
import { useLocation } from "react-router";
import { MarketingEventLogAPIService } from "./api-service";

const useCaptureEvent = () => {
    const location = useLocation();

    const captureEvent = useCallback(
        (IPAddressTxt, EventLogTypeDsc, EventLogDsc) => {
            MarketingEventLogAPIService.addMarketingEventLog({
                IPAddressTxt,
                DeviceDsc: deviceDetect(getUA).isMobile ? `${deviceDetect(getUA).vendor} ${deviceDetect(getUA).model}` : `${deviceDetect(getUA).browserName} ${deviceDetect(getUA).osName}`,
                EventLogTypeDsc,
                EventLogDsc,
                EventPageUrlTxt: location.pathname + location.search + location.hash,
                DeviceDimensionsTxt: `${window.innerWidth}X${window.innerHeight}`,
            });
        },
        [location.pathname, location.search, location.hash]
    );

    return captureEvent;
};

export default useCaptureEvent;